export default "__VITE_ASSET__C2C$HzRM__"